export default function FantasyTeam() {
    const team = {
      "Wicket Keepers": [
        { name: "Dhoni", points: 9.5 },
        { name: "Kishan", points: 11 },
      ],
      Batsmen: [
        { name: "Rohit", points: 11 },
        { name: "Kohli", points: 12.5 },
        { name: "Du Plessis", points: 9.5 },
        { name: "Iyer", points: 8.5 },
      ],
      "All Rounders": [
        { name: "Maxwell", points: 10 },
        { name: "Russel", points: 9 },
      ],
      Bowlers: [
        { name: "Kuldeep", points: 8 },
        { name: "Siraj", points: 9.5 },
        { name: "Thakur", points: 8 },
      ],
    };
  
    return (
      <div className="flex flex-col items-center space-y-4 p-4 bg-green-900 min-h-screen text-white">
        {Object.entries(team).map(([role, players]) => (
          <div key={role} className="w-full text-center">
            <h2 className="text-xl font-bold bg-gray-800 py-2 mb-2">{role}</h2>
            <div className="flex justify-center space-x-4 overflow-x-auto">
              {players.map((player, index) => (
                <div key={index} className="bg-gray-700 p-3 rounded-lg shadow-lg text-center">
                  <p className="font-semibold">{player.name}</p>
                  <p className="text-sm">{player.points} pts</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }
  